module.exports = __webpack_public_path__ + "media/images/betaTab-125e2acf7b72aa54741ef611943d696c.svg";